import { isDev } from "../utils/isDev";
import { useCheckPermission } from "../utils/permissions/Chowkidar";
import { PermissionTypes } from "@certa/types";

export const useCanViewHermesUI = () => {
  const canSeeHermesUI = useCheckPermission(
    PermissionTypes.CAN_READ_HERMES_DATA
  );

  return isDev || canSeeHermesUI;
};
